import { useAuth } from "@/hooks/useAuth";
import { isExplicitSeedViewer } from "@/lib/demoAccountFilters";

/**
 * Canonical predicate for deciding whether the current viewer is a demo
 * identity that should see seed data. Human demo identities are allowlisted by
 * UUID per environment; the dev smoke identity is a separate non-human
 * exception. Email aliases and profile fields do not grant access.
 */
export function useIsSeedViewer(): boolean {
  const { user } = useAuth();
  return isExplicitSeedViewer(user?.id);
}
